<template>
  <div class="company-main-content">
    <div class="main-content">
      <div class="left-content">
        <el-image :src="teamImg" lazy></el-image>
      </div>
      <div class="right-content">
        <h3>峰学未来简介</h3>
        <p>峰学未来由名师张雪峰于2021年一手创立，集团总部坐落在中国最强园区：苏州工业园区。
          依托于苏州重点高校、科研院所和优质的企业资源，峰学未来致力于打造一体化的人才培养及教育生态平台，
          打通人才培养、升学规划及优质就业的绿色通道。</p>
      </div>
    </div>
  </div>
</template>

<script>
import teamImg from '../assets/img/index-introduce.jpg';
export default {
  name: "CompanyContent",
  data() {
    return {
      teamImg:teamImg
    }
  }
}
</script>

<style lang="scss" scoped>
@font-face {
  font-family: 'SourceHanSansCN';
  src: url('https://oss.fxwljy.com/attach/file1706509868982.otf');
}
@font-face {
  font-family: 'SourceHanSansCNBold';
  src: url('https://oss.fxwljy.com/attach/file1706509868791.otf');
}
.company-main-content{
  width: 100%;
  background: #FFFFFF;
  margin: 0 auto;
  height: 500px;
  /*padding: 120px 0;*/
  .main-content{
    width: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .right-content{
      width: 50%;
      h3{
        font-size: 40px;
        font-family: 'SourceHanSansCNBold Microsoft YaHei' !important;
        font-weight: bold;
        color: #0A0D0F;
        line-height: 60px;
        letter-spacing: 2px;
        padding-left: 60px;
      }
      p{
        font-size: 18px;
        font-family: 'SourceHanSansCN Microsoft YaHei';
        font-weight: 400;
        color: #434649;
        line-height: 40px;
        letter-spacing: 1px;
        margin-top: 30px;
        text-align: justify;
        padding-left: 60px;
        padding-right: 360px;
      }
    }
    .left-content{
      width: 50%;
      .el-image{
        width: 100%;
        height: 500px;
      }
    }
  }
}
</style>